module.exports = __webpack_public_path__ + "img/card-camera.965bdec7.png";